import { useActions } from "@/overmind";
export function useHighlightGridElementInMap() {
  const { highlight, stopHighlighting } = useActions().map;
  // @ts-ignore
  return {
    highlight: (..._args: any[]) => {
      highlight(_args[0]);
    },
    stopHighlighting: (..._args: any[]) => {
      stopHighlighting();
    }
  };
}
